<template>
	<div>
		<tableBox  :url="'/Flat/SelUserAssessment'" :exportUrl="'/Flat/ExportUserAssessment'" :ifState="true" :ifSearch="true"  :columns="columns"></tableBox>
	</div>
</template>

<script>
	import tableBox from '../../../components/tableBox.vue'
	export default {
		name:'/core/onlineExam',
		components: {
			tableBox
		},
		data() {
			return {

				columns: [{
						title: '试卷名称',
						dataIndex: 'examPaperName',
						key: 'examPaperName',
					},
					{
						title: '平台',
						key: 'labname',
						dataIndex: 'labname',
						
						aligh:'center'
					},
					{
						title: '考试时长（min）',
						dataIndex: 'examMinute',
						key: 'examMinute',
					},
					{
						title: '分数',
						dataIndex: 'mark',
						key: 'mark'

					},
					{
						title: '满分',
						key: 'fraction',
						dataIndex: 'fraction',
					},
					{
						title: '及格分',
						key: 'passMark',
						dataIndex: 'passMark',

					},
					{
						title: '结果',
						key: 'isPass',
						dataIndex: 'isPass',
						scopedSlots: {
							customRender: 'isPass'
						}
					},
					{
						title: '操作',
						dataIndex: 'onlineExam',
						scopedSlots: {
							customRender: 'onlineExam'
						},
					},
				]
				
			}
		}
	};
</script>

<style>
</style>
